module.exports = __webpack_public_path__ + "img/icon-checked.4810941d.svg";